const TechnologyCard = require("../../entities/Cards/TechnologyCard");
const TechnologyLookup = require("../TechnologyLookup");

// (version: of a technology the expansion changed, see Constants/CardVersions.js)
const TechnologyConverter = (technologyName, version) =>
{
    const Technology = TechnologyLookup(technologyName);
    return Technology === null ? null : new TechnologyCard(Technology, version);
}

module.exports = TechnologyConverter;
